import { Box } from '@/components/Box/Box';
import { Typography } from '@/components/Typography/Typography';
import { DATE_TIME_FORMAT, formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { StatusVariantType } from '@/components/StatusWrapper/const';

type StampType = { kind: string; at: string } | null;

type StatusCellType = {
  label: string;
  stamp?: StampType;
  variant: StatusVariantType;
};

export const StatusCell = ({ label, stamp, variant }: StatusCellType) => {
  return (
    <Box display='flex' flexDirection='column' gap='4px' alignItems='flex-start'>
      <StatusWrapper variant={variant}>{label}</StatusWrapper>
      {stamp && (
        <Typography variant='bodySmall2' fontWeight='medium'>
          {formatDate(stamp.at, DATE_TIME_FORMAT)}
        </Typography>
      )}
    </Box>
  );
};
